<template>
  <button class="btn d-button" :class="[{ disabled: disabled }, _variant]" :disabled="disabled">
    <div class="position-relative">
      <d-row class="d-flex align-items-center g-0" :class="[{ 'opacity-0': _loading }]">
        <d-col v-if="icon" cols="auto" class="pe-2" >
            <d-svg v-if="icon" :src="icon" width="1.5em" height="1.5em"></d-svg>     
        </d-col>
        <d-col class="my-auto" v-if="hasdefaultslot">
            <p class="my-0">
                <slot></slot>
            </p>
        </d-col>            
    </d-row>    
    <LoaderLottie v-if="_loading" class="position-absolute top-0 start-0 w-100 h-100" ></LoaderLottie>
    </div>    
  </button>
</template>

<script setup>
import { computed, defineProps, useSlots } from 'vue'
import LoaderLottie from "./Lottie/DLottieLoader.vue"

const slots = useSlots();

// PROPS
const props = defineProps({
    hidetext: String, // sm, md.lg xl
    hideicon: String,
    size: String,
    variant: String,
    icon: String,
    to: String,
    target: String,
    disabled: Boolean,
    loading: Boolean,
    pill: Boolean,
    squared: Boolean,
    noVariant: Boolean,
})

// computed
const _variant = computed(() => {
  return props.noVariant ? "" : "btn-" + (props.variant ?? "primary")
})

const _loading = computed(() => props.loading)

const hasdefaultslot = computed(() => slots.default)

</script>

